import { useEffect, useState } from "react";
import { Country } from "../models/Country";
import { fetchCountries } from "../api/countryApi";

const CountryListPage = () => {
    const [countries, setCountries] = useState<Country[]>([]);

    useEffect(() => {
        fetchCountries().then(setCountries);
    }, []);

    return (
        <div>
            <h1>Country List</h1>
            <ul>
                {countries.map((country) => (
                    <li key={country.countryCode}>
                        {country.countryName} ({country.countryCode})
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CountryListPage;
